import React from "react";
import { Link } from "react-router-dom";
import "./StatisticsCard.scss";
interface Props {
  customClass: string;
  text: string;
  count: string;
  link: string;
  icon: string;
}

const StatisticsCard: React.FC<Props> = ({
  customClass,
  text,
  count,
  link,
  icon,
}) => {
  return (
    <div className=" card-main-parent" >
      <div className="content">
        <img src={icon} />
        <div style={{ flexDirection: "column", textAlign: "right" }}>
          <h5>{text}</h5>
          <p>{count}</p>
        </div>
      </div>
      <Link to={link}>
        <div className={`link-parent ${customClass}`}>
          <p>VIEW MORE</p>
        </div>
      </Link>
    </div>
  );
};

export default StatisticsCard;
